export class VMConfig {
    selectedSubscriptionID: string = null;
    rgField: string = 'Existing';
    vmResourceGroup: string = '';
    clientDefinedName: string = '';
    generatedVMName: string = '';
    serverNumber: string = '00';
    lineOfBusiness: string = 'Wood Products';
    environment: string = 'Development';
    role: string = 'Web Servers';
    region: string = 'westus2';
    username: string = 'WyAdmin';
    password: string = '';
    vnetResourceGroup: string = '';
    virtualNetwork: string = '';
    nicName: string = '';
    subnet: string = '';
    ipAddressType: string = 'Dynamic';
    joinToDomain: string = 'no';
    availabilitySet: string = 'no';
    vmSize: string = '';
    rgNumber: string = '01';
    tagProject: string = '';
    tagCostCenter: string = '';
    tagEnvironment: string = '';
    tagExpirationDate: string = '';
    tagRole: string = '';
    tagApplicationName: string = '';
    tagPrimaryContact: string = '';
    tagSchedule: string = '';
    tagBusiness: string = '';
    tagDRTier: string = '';
    tagWorkgroup: string = '';
    tagComplianceRequirement: string = '';
    tagConfidentialityLevel: string = '';
    tagSector: string = '';
    sku: string = '';
    skuLabel: string = '';
    publisher: string = '';
    offer: string = '';
    osDiskType: string = 'StandardSSD_LRS';
    dataDisksArray: any[] = [];    
    
    subscriptionList: object[] = [];
    passwordValidated: boolean = false; 

    constructor(subscriptionList: object[]) {
        this.subscriptionList = subscriptionList;
        
        if (this.subscriptionList && this.subscriptionList.length > 0)
            this.selectedSubscriptionID = this.subscriptionList[0]["id"];
    }

    isValid() {
        // regular expression for the Azure VM password requirements
        var patt = new RegExp("^((?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])|(?=.*[0-9])(?=.*[a-z])(?=.*[!@#$%^&*])|(?=.*[0-9])(?=.*[A-Z])(?=.*[!@#$%^&*])|(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*])).{12,123}$");
        this.passwordValidated = patt.test(this.password);

        // disable create button if any of these are empty or undefined
        return (this.clientDefinedName != undefined && this.clientDefinedName != '') &&
                (this.username != undefined && this.username != '') &&
                (this.tagDRTier != undefined && this.tagDRTier != '') &&
                (this.serverNumber != undefined && this.serverNumber != '') &&
                (this.password != undefined && this.password != '') &&
                // costcenter is removed from required fields, do not use in form validation
                // (this.tagCostCenter != undefined && this.tagCostCenter != '') &&
                (this.tagWorkgroup != undefined && this.tagWorkgroup != '') &&
                (this.lineOfBusiness != undefined && this.lineOfBusiness != '') &&
                (this.vmResourceGroup != undefined && this.vmResourceGroup != '') &&
                //(this.vnetResourceGroup != undefined && this.vnetResourceGroup != '') &&
                (this.tagEnvironment != undefined && this.tagEnvironment != '') &&
                (this.environment != undefined && this.environment != '') &&
                //(this.virtualNetwork != undefined && this.virtualNetwork != '') &&
                //(this.subnet != undefined && this.subnet != '') &&
                (this.region != undefined && this.region != '') &&
                (this.tagApplicationName != undefined && this.tagApplicationName != '') &&
                (this.tagPrimaryContact != undefined && this.tagPrimaryContact != '') &&
                (this.rgNumber != undefined && this.rgNumber != '') &&
                (this.vmSize != undefined && this.vmSize != '') &&
                (this.sku != undefined && this.sku != '') &&
                (this.publisher != undefined && this.publisher != '') &&
                (this.offer != undefined && this.offer != '') &&
                this.passwordValidated == true;
    }

    // all VM names have an auto-generated component to them
    generateVmName() {
        var lineOfBusinessCode = null;
        var environmentCode = null;
        var roleCode  = null;

        if (this.lineOfBusiness == 'Wood Products') { lineOfBusinessCode = 'wp'; }
        else if (this.lineOfBusiness == 'Infrastructure Services') { lineOfBusinessCode = 'is'; }
        else if (this.lineOfBusiness == 'Corp Functions') { lineOfBusinessCode = 'cf'; }
        else if (this.lineOfBusiness == 'Timberlands') { lineOfBusinessCode = 'tl'; }

        if (this.environment == 'Production') { environmentCode = 'prd'; }
        else if (this.environment == 'Development') { environmentCode = 'dev'; }
        else if (this.environment == 'QA/Test') { environmentCode = 'tst'; }
        else if (this.environment == 'Production DMZ') { environmentCode = 'dmz'; }
        else if (this.environment == 'Test DMZ') { environmentCode = 'dmt'; }
        else if (this.environment == 'Dev DMZ') { environmentCode = 'dmd'; }

        if (this.role == 'Web Servers') { roleCode = 'web'; }
        else if (this.role == 'Database Servers') { roleCode = 'dbs'; }
        else if (this.role == 'Application Servers') { roleCode = 'app'; }
        else if (this.role == 'Operations') { roleCode = 'ops'; }
        else if (this.role == 'Domain Controllers') { roleCode = 'dir'; }
        else if (this.role == 'Terminal & Citrix Servers') { roleCode = 'ter'; }
        else if (this.role == 'Security') { roleCode = 'sec'; }
        else if (this.role == 'Reporting') { roleCode = 'rpt'; }
        else if (this.role == 'Workstations') { roleCode = 'wks'; }

        this.generatedVMName = `${lineOfBusinessCode}${environmentCode}${roleCode}${this.clientDefinedName}${this.serverNumber}`;
    }

    // users may auto-generate the RG name
    generateRGName() {
        var regionCode = null;
        var environmentCode = null;
        var roleCode  = null;

        if (this.region == 'westus2') { regionCode = 'w2' }
        else if (this.region == 'westcentralus') { regionCode = 'wc' }

        if (this.environment == 'Production') { environmentCode = 'prd'; }
        else if (this.environment == 'Development') { environmentCode = 'dev'; }
        else if (this.environment == 'QA/Test') { environmentCode = 'tst'; }
        else if (this.environment == 'Production DMZ') { environmentCode = 'dmz'; }
        else if (this.environment == 'Test DMZ') { environmentCode = 'dmt'; }
        else if (this.environment == 'Dev DMZ') { environmentCode = 'dmd'; }

        if (this.role == 'Web Servers') { roleCode = 'web'; }
        else if (this.role == 'Database Servers') { roleCode = 'dbs'; }
        else if (this.role == 'Application Servers') { roleCode = 'app'; }
        else if (this.role == 'Operations') { roleCode = 'ops'; }
        else if (this.role == 'Domain Controllers') { roleCode = 'dir'; }
        else if (this.role == 'Terminal & Citrix Servers') { roleCode = 'ter'; }
        else if (this.role == 'Security') { roleCode = 'sec'; }
        else if (this.role == 'Reporting') { roleCode = 'rpt'; }
        else if (this.role == 'Workstations') { roleCode = 'wks'; }

        if (this.rgField != 'Free Form' && this.rgField != 'Existing') {
            this.vmResourceGroup = `z-${regionCode}-${environmentCode}-${roleCode}-rgp-${this.clientDefinedName}-${this.rgNumber}`;
        }
    }

    exportConfig() {
        var subscriptionName = null;
        if (this.selectedSubscriptionID && this.subscriptionList) {
            var subscription = this.subscriptionList.find(s => s["id"] == this.selectedSubscriptionID);
            if (subscription)
                subscriptionName = subscription["name"]
        }
        return {
            subscriptionID: this.selectedSubscriptionID,
            subscriptionName: subscriptionName,
            vmResourceGroupType: this.rgField,
            vmResourceGroup: this.vmResourceGroup,
            clientDefinedName: this.clientDefinedName,
            generatedVMName: this.generatedVMName,
            serverNumber: this.serverNumber,
            lineOfBusiness: this.lineOfBusiness,
            environment: this.environment,
            role: this.role,
            region: this.region,
            localAdminName: this.username,
            localAdminPassword: this.password,
            vnetResourceGroup: this.vnetResourceGroup,
            virtualNetwork: this.virtualNetwork,
            nicName: this.nicName,
            subnet: this.subnet,
            ipAddressType: this.ipAddressType,
            joinToDomain: this.joinToDomain,
            availabilitySet: this.availabilitySet,
            vmSize: this.vmSize,
            resourceGroupNumber: this.rgNumber,
            tagProject: this.tagProject,
            tagCostCenter: this.tagCostCenter,
            tagEnvironment: this.tagEnvironment,
            tagExpirationDate: this.tagExpirationDate,
            tagRole: this.tagRole,
            tagApplicationName: this.tagApplicationName,
            tagPrimaryContact: this.tagPrimaryContact,
            tagSchedule: this.tagSchedule,
            tagBusiness: this.tagBusiness,
            tagDRTier: this.tagDRTier,
            tagWorkgroup: this.tagWorkgroup,
            tagComplianceRequirement: this.tagComplianceRequirement,
            tagConfidentialityLevel: this.tagConfidentialityLevel,
            tagSector: this.tagSector,
            azureOS: this.sku,
            azureSkuLabel: this.skuLabel,
            publisher: this.publisher,
            offer: this.offer,
            osDiskType: this.osDiskType,
            dataDisks: this.dataDisksArray
        };
    }

    loadFromConfigFile(file: object) {
        this.selectedSubscriptionID = file["subscriptionID"];
        this.rgField = file["vmResourceGroupType"]; 
        this.vmResourceGroup = file["vmResourceGroup"];
        this.clientDefinedName = file["clientDefinedName"];
        this.generatedVMName = file["generatedVMName"];
        this.serverNumber = file["serverNumber"];
        this.lineOfBusiness = file["lineOfBusiness"];
        this.environment = file["environment"];
        this.role = file["role"];
        this.region = file["region"];
        this.username = file["localAdminName"];
        this.password = file["localAdminPassword"];
        this.vnetResourceGroup = file["vnetResourceGroup"];
        this.virtualNetwork = file["virtualNetwork"];
        this.nicName = file["nicName"],
        this.subnet = file["subnet"];
        this.ipAddressType = file["ipAddressType"];
        this.joinToDomain = file["joinToDomain"];
        this.availabilitySet = file["availabilitySet"];
        this.vmSize = file["vmSize"];
        this.rgNumber = file["resourceGroupNumber"];
        this.tagProject = file["tagProject"];
        this.tagCostCenter = file["tagCostCenter"];
        this.tagEnvironment = file["tagEnvironment"];
        this.tagExpirationDate = file["tagExpirationDate"];
        this.tagRole = file["tagRole"];
        this.tagApplicationName = file["tagApplicationName"];
        this.tagPrimaryContact = file["tagPrimaryContact"];
        this.tagSchedule = file["tagSchedule"];
        this.tagBusiness = file["tagBusiness"];
        this.tagDRTier = file["tagDRTier"];
        this.tagWorkgroup = file["tagWorkgroup"];
        this.tagComplianceRequirement = file["tagComplianceRequirement"];
        this.tagConfidentialityLevel = file["tagConfidentialityLevel"];
        this.tagSector = file["tagSector"];
        this.sku = file["azureOS"];
        // prevent config conflicts with new SKU property
        this.skuLabel = file["azureSkuLabel"] || ''; 
        this.publisher = file["publisher"] || '';
        this.offer = file["offer"] || '';
        this.osDiskType = file["osDiskType"];
        this.dataDisksArray = file["dataDisks"];
    }
}
